export default "/wind.b986923a-69ca2a.svg";